export default {
  header: 'Bitte eingeben',
  processFlow: 'Ablauf',
  box: 'Box',
  prio: 'Prio',
  testLoad: 'Testcharge',
};
